import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useBreedsServices = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const speciesId = +urlQueries["species-id"] || "";
  const created_between = urlQueries["created_between"] || "";

  const allBreedsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.BREEDS,
      debouncedQuery,
      speciesId,
      page,
      per_page,
      created_between,
    ],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS.BREEDS,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[species_id]": speciesId,
          "filter[created_between]": created_between,
          page,
          per_page,
        },
      });
    },
    enabled: enableQuery,
  });
  return {
    services: { allBreedsService },
    states: { searchQuery, setSearchQuery },
  };
};
